import React, { useState, useEffect } from 'react';
import './index.scss';
import { navigateTo } from '@/Utils/routing';

const KoreanStudyType: React.FC = () => {
    const carouselData = [
        { image: '/img/roomtype_si_idol_stan.jpg', text: 'Si idol stan', badge: '/img/type_si_idol_stan.svg' },
        { image: '/img/roomtype_k_content_lover.jpg', text: 'K-content lover', badge: '/img/type_k_content_lover.svg' },
        { image: '/img/roomtype_social_butterfly.jpg', text: 'Social butterfly', badge: '/img/type_social_butterfly.svg' },
        { image: '/img/roomtype_casual_learner.jpg', text: 'Casual learner', badge: '/img/type_casual_learner.svg' },
        { image: '/img/roomtype_si_calon_traveler.jpg', text: 'Si Calon Traveler', badge: '/img/type_si_calon_traveler.svg' },
        { image: '/img/roomtype_si_akademis.jpg', text: 'Si Akademis', badge: '/img/type_si_akademis.svg' },
        { image: '/img/roomtype_si_paling_estetik.jpg', text: 'Si Paling Estetik', badge: '/img/type_si_paling_estetik.svg' },
        { image: '/img/roomtype_skill_hunter.jpg', text: 'Skill hunter', badge: '/img/type_skill_hunter.svg' },
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % carouselData.length);
        }, 2500);

        return () => clearInterval(interval);
    }, [carouselData.length]);

    return (
        <div className="korean-study-type-container">
            {/* Top Section */}
            <div className="top-section">
                <div className="main-title">
                    <img src="/img/topimg.jpg" alt="Korean Language Personality Test" />
                </div>
                
                {/* 이미지 섹션 - 크로스페이드 애니메이션 */}
                <div className="image-section">
                    <div className="carousel-container">
                        <div className="dissolve-wrapper">
                            {carouselData.map((item, index) => (
                                <div 
                                    key={index}
                                    className={`dissolve-item ${index === activeIndex ? 'active' : ''}`}
                                >
                                    <img src={item.image} alt="Room" />
                                </div>
                            ))}
                        </div>
                        <div className="type-tags-container">
                            {carouselData.map((item, index) => (
                                <div className={`type-tag-wrapper ${index === activeIndex ? 'active' : ''}`}>
                                    <div 
                                        key={index}
                                        className={`type-tag`}
                                    >
                                        <div className="tag-avatar-wrapper">
                                            <div className="tag-avatar">
                                                <img src="/img/avatasilluet.png" alt="Avatar Silhouette" />
                                            </div>
                                            <div className="tag-badge">
                                                <img src={item.badge} alt="Badge" />
                                            </div>
                                        </div>
                                        <span className="tag-text">{item.text}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Intro Section */}
            <div className="intro-section">
                <h2 className="intro-title">
                    {"Tes ini menunjukkan kepribadianku saat belajar bahasa Korea.\nAyo coba untuk seru-seruan!"}
                </h2>
                
                {/* 아이콘 그리드 */}
                <div className="icons-container">
                    <div className="icons-row">
                        <div className="icon-circle">
                            <img src="/img/type_skill_hunter.svg" alt="Skill Hunter" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_social_butterfly.svg" alt="Social Butterfly" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_k_content_lover.svg" alt="K-Contents Lover" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_si_idol_stan.svg" alt="Idol Stan" />
                        </div>
                    </div>
                    <div className="icons-row offset">
                        <div className="icon-circle">
                            <img src="/img/type_si_paling_estetik.svg" alt="Gamsung" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_si_calon_traveler.svg" alt="Travel" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_si_akademis.svg" alt="Bookman" />
                        </div>
                        <div className="icon-circle">
                            <img src="/img/type_casual_learner.svg" alt="Casual Learner" />
                        </div>
                    </div>
                </div>

                {/* 설명 카드 */}
                <div className="info-card">
                    <div className="info-item">
                        <div className="info-icon">
                            <img src="/svg/Bars.svg" alt="Bars" />
                        </div>
                        <div className="info-content">
                            <h3>{"Kenalan Sama 'Versi Belajar Bahasa Korea' dalam Dirimu!"}</h3>
                            <p>{"Penasaran kamu tuh tipe yang seperti apa saat belajar Bahasa Korea? Mate akan gambarin lewat sebuah \"ruangan\" yang mencerminkan gaya belajarmu."}</p>
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="info-icon">
                            <img src="/svg/Heart.svg" alt="Heart" />
                        </div>
                        <div className="info-content">
                            <h3>{"Jangan lupa untuk pamerin hasilnya!"}</h3>
                            <p>{"Masukkan avatar versimu ke dalam ruangan tersebut dan bikin foto yang keren buat dishare ke yang lain!"}</p>
                        </div>
                    </div>
                    <div className="info-item">
                        <div className="info-icon">
                            <img src="/svg/Stopwatch.svg" alt="Stopwatch" />
                        </div>
                        <div className="info-content">
                            <h3>{"Hanya butuh waktu 2 menit saja!"}</h3>
                            <p>{"Tes ini terdiri dari 10 pertanyaan. Kamu bisa langsung tau tipe belajar seperti apa yang paling cocok untukmu. Ingat, nggak ada jawaban yang benar dan salah disini!"}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
                <button className="cta-button" onClick={() => navigateTo('/personatest/koreanstudytype/question/01')}>
                {"Mulai Tes Gaya Belajar Bahasa Korea"}
                </button>
            </div>

            {/* Footer Section */}
            <div className="footer-section">
                <div className="footer-left">
                    <span className="footer-logo">{"MATE"}</span>
                    <span className="footer-subtitle">{"Talk&Learn Korean"}</span>
                </div>
                <div className="footer-icon">
                    <img src="/img/matelogo_gray.png" alt="MATE Logo" />
                </div>
            </div>
        </div>
    );
};

export default KoreanStudyType;
